import { render, staticRenderFns } from "./OpenPositionsDetail.vue?vue&type=template&id=ce9a845c"
import script from "./OpenPositionsDetail.vue?vue&type=script&lang=js"
export * from "./OpenPositionsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports